<template>
  <div class="content-block">
    <div class="asd-form-section heading-section">
      <h1>Flexiservis sync</h1>
      <ActiveButton class="asd-btn-confirm asd-btn-single-icon"
                    :click="save"
      >
        <i class="fas fa-save"></i>
      </ActiveButton>
    </div>
    <div class="asd-form-section">
      <div class="asd-grid-row asd-grid-row__cp0">
        <div>
          <label>API Url</label>
          <input v-model="settings.api.url"
                 class="asd-input"
          />
        </div>
        <div>
          <label>API Token</label>
          <input v-model="settings.api.token"
                 class="asd-input"
          />
        </div>
        <div>
          <label>Pracovnik</label>
          <UIPropertyTypeSelect v-model="settings.pracovnik"
                                :max="1"
          ></UIPropertyTypeSelect>
        </div>
        <div>
          <label>Vytvoril</label>
          <UIPropertyTypeSelect v-model="settings.creatorId"
                                :max="1"
          ></UIPropertyTypeSelect>
        </div>
        <div>
          <label>Dokončit do</label>
          <UIPropertyTypeSelect v-model="settings.datTermin"
                                :max="1"
          ></UIPropertyTypeSelect>
        </div>
        <div>
          <label>Datum vystaveni</label>
          <UIPropertyTypeSelect v-model="settings.datVyst"
                                :max="1"
          ></UIPropertyTypeSelect>
        </div>
        <div>
          <label>Popis</label>
          <UIPropertyTypeSelect v-model="settings.popips"></UIPropertyTypeSelect>
        </div>
        <div>
          <label>Typ dokladu</label>
          <Multiselect
            v-model="settings.typDokl"
            :max="1"
            label="label"
            trackBy="id"
            valueByPath="id"
            :returnAsSingle="true"
            :options="typyDoklOptions"
          >
          </Multiselect>
        </div>
      </div>

      <div class="asd-grid-row asd-grid-row__cp0">
        <table v-if="pracovnici.length > 0"
               class="asd-table"
        >
          <thead>
            <tr class="table-heading">
              <th>ASD uživatelské jméno</th>
              <th>Flexiservis uživatelské jméno</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="u in users"
                :key="u.id"
            >
              <td>{{ u.username }}</td>
              <td>
                <Multiselect
                  v-model="settings.usersPracovnici[u.id]"
                  :max="1"
                  label="label"
                  trackBy="id"
                  valueByPath="id"
                  :options="pracovnici"
                  :returnAsSingle="true"
                >
                </Multiselect>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else
             class="box-loader"
        >
          <i class="fas fa-sync fa-spin"></i>
        </div>

        <table v-if="pracovnici.length > 0"
               class="asd-table"
        >
          <thead>
            <tr class="table-heading">
              <th>ASD zdroj</th>
              <th>Flexiservis uzivatelske jmeno</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in resources"
                :key="r.id"
            >
              <td>{{ r.label }}</td>
              <td>
                <Multiselect
                  v-model="settings.resourcesPracovnici[r.id]"
                  :max="1"
                  label="label"
                  trackBy="id"
                  valueByPath="id"
                  :options="pracovnici"
                  :returnAsSingle="true"
                >
                </Multiselect>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else
             class="box-loader"
        >
          <i class="fas fa-sync fa-spin"></i>
        </div>
      </div>

      <div class="asd-grid-row">
        <pre>
            {{ usersPracovnici }}
        </pre>
        <pre>
            {{ resourcesPracovnici }}
        </pre>
      </div>
    </div>
  </div>
</template>

<script>
import { get, map } from 'lodash'
import ActiveButton from 'CORE/components/form/active-button'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import UIPropertyTypeSelect from 'CORE/components/utilities/ui-property-type-select.vue'
import axios from 'axios'
import labels from 'CORE/utils/labels'
import EventBus from 'CORE/bus'

export default {
    name: 'FlexiservisSettings',
    components: {
        ActiveButton,
        Multiselect,
        UIPropertyTypeSelect,
    },
    props: {
        instanceId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            settings: false,
            pracovnici: [],
            firmy: [],
        }
    },
    computed: {
        users() {
            return this.$store.getters.users
        },
        resources() {
            return map(this.$store.getters.resources, r => {
                return { id: r.id, label: labels.resource(r) }
            })
        },
        typyDoklOptions() {
            return [{ id: 'SP', label: 'Servisni pozadavek' }]
        },
    },
    async mounted() {
        const settings = await axios.get(`/workflow/settings/flexiservis_sync/${this.instanceId}`)
        this.$set(this, 'settings', get(settings, 'data'))
        await this.loadPracovnici()
    },
    methods: {
        async save() {
            try {
                await axios.put(`/workflow/settings/flexiservis_sync/${this.instanceId}`, this.settings)
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
            } catch (e) {
                EventBus.$emit('FLASH_USER_ERROR', {
                    message: 'Chyba při uložení',
                })
            }
        },
        async loadPracovnici() {
            const pracovnici = await axios.get(`/workflow/settings/flexiservis_sync/${this.instanceId}/pracovnici`)
            this.pracovnici = get(pracovnici, 'data', [])
        },
        async loadFirmy() {
            const firmy = await axios.get(`/workflow/settings/flexiservis_sync/${this.instanceId}/firmy`)
            this.firmy = get(firmy, 'data', [])
        },
    },
}
</script>

<style lang="scss">
.asd-grid {
    &-row {
        display: flex;
        & > * {
            flex-grow: 1;
        }
        &__cp0 > * {
            margin: 10px;
        }
    }
}
.box-loader {
    width: 100%;
    border: 1px solid var(--color-secondary);
    border-radius: 7px;
    background-color: rgba(0, 0, 0, 0.07);
    text-align: center;
    padding: 10px;
}
</style>
